/**
 * Every movement the apps know, in English and Italian, for completing a name as it is typed.
 *
 * Exported from the apps' exercise library (GymquisitionKit's ExerciseLibrary), not written by
 * hand: a coach who types "Panca" here should be offered the same spelling the athlete's phone
 * uses, or the same lift ends up with two histories. Regenerate it when the library changes.
 */
export const EXERCISE_NAMES: readonly string[] = [
  "Ab wheel rollout",
  "Abduttori alla macchina",
  "Adduttori alla macchina",
  "Affondi camminati",
  "Affondo bulgaro",
  "Alzate frontali",
  "Alzate laterali",
  "Alzate laterali ai cavi",
  "Alzate laterali con elastico",
  "Alzate posteriori",
  "Arnold press",
  "Assault bike",
  "Back extension",
  "Back squat",
  "Band curl",
  "Band lateral raise",
  "Band row",
  "Barbell bench press",
  "Barbell row",
  "Battle rope",
  "Battle ropes",
  "Bench dip",
  "Biceps curl",
  "Bodyweight squat",
  "Box jump",
  "Bulgarian split squat",
  "Burpee",
  "Cable crunch",
  "Cable curl",
  "Cable fly",
  "Cable lateral raise",
  "Calf raise con carico",
  "Calf raise in piedi",
  "Calf raise seduto",
  "Cardio a bassa intensità",
  "Cardio a intervalli",
  "Chest dip",
  "Chest press alla macchina",
  "Chest-supported row",
  "Chin-up",
  "Clean and jerk",
  "Close-grip bench press",
  "Concentration curl",
  "Corda per saltare",
  "Corsa sul tapis roulant",
  "Croci ai cavi",
  "Croci con manubri",
  "Crunch ai cavi",
  "Curl a martello",
  "Curl ai cavi",
  "Curl con elastico",
  "Curl di concentrazione",
  "Curl per bicipiti",
  "Curl per polsi",
  "Curl su panca inclinata",
  "Curl su panca Scott",
  "Cyclette",
  "Dead bug",
  "Deadlift",
  "Decline bench press",
  "Diamond push-up",
  "Dip alle parallele",
  "Dip fra le panche",
  "Dumbbell bench press",
  "Dumbbell fly",
  "Dumbbell Romanian deadlift",
  "Dumbbell row",
  "Dumbbell shoulder press",
  "Elliptical",
  "Ellittica",
  "Estensioni sopra la testa",
  "Face pull",
  "Farmer's walk",
  "French press",
  "Front raise",
  "Front squat",
  "Girata al petto",
  "Glute bridge",
  "Goblet squat",
  "Good morning",
  "Hack squat",
  "Hammer curl",
  "Hanging knee raise",
  "Hanging leg raise",
  "Hip thrust",
  "Incline barbell bench press",
  "Incline dumbbell curl",
  "Incline dumbbell press",
  "Interval cardio",
  "Inverted row",
  "Iperestensioni",
  "Jump rope",
  "Kettlebell swing",
  "Kickback per tricipiti",
  "Lat machine",
  "Lat pulldown",
  "Lateral raise",
  "Leg abduction",
  "Leg adduction",
  "Leg curl sdraiato",
  "Leg curl seduto",
  "Leg extension",
  "Leg press",
  "Lento avanti",
  "Lento con manubri",
  "Loaded calf raise",
  "Low-intensity cardio",
  "Lying leg curl",
  "Machine chest press",
  "Military press",
  "Mobilità e stretching",
  "Mobility and stretching",
  "Overhead triceps extension",
  "Panca declinata",
  "Panca inclinata con bilanciere",
  "Panca inclinata con manubri",
  "Panca piana con bilanciere",
  "Panca piana con manubri",
  "Panca presa stretta",
  "Pec deck",
  "Pectoral machine",
  "Pendlay row",
  "Piegamenti",
  "Piegamenti a diamante",
  "Piegamenti a V",
  "Pike push-up",
  "Plank",
  "Ponte per glutei",
  "Power clean",
  "Preacher curl",
  "Pull-up",
  "Pulley basso",
  "Pullover ai cavi",
  "Push down per tricipiti",
  "Push-up",
  "Rack pull",
  "Rematore a T",
  "Rematore australiano",
  "Rematore con appoggio",
  "Rematore con bilanciere",
  "Rematore con elastico",
  "Rematore con manubrio",
  "Reverse fly",
  "Romanian deadlift",
  "Rowing machine",
  "Ruota per addominali",
  "Russian twist",
  "Salti sul box",
  "Scrollate",
  "Seated cable row",
  "Seated calf raise",
  "Seated leg curl",
  "Shrug",
  "Sit-up",
  "Skull crusher",
  "Slancio",
  "Snatch",
  "Sollevamento gambe alla sbarra",
  "Sollevamento ginocchia alla sbarra",
  "Squat a corpo libero",
  "Squat con bilanciere",
  "Stacco da terra",
  "Stacco rumeno",
  "Stacco rumeno con manubri",
  "Stacco sumo",
  "Stair climber",
  "Standing calf raise",
  "Stationary bike",
  "Step-up",
  "Straight-arm pulldown",
  "Strappo",
  "Sumo deadlift",
  "Superman",
  "Swing con kettlebell",
  "T-bar row",
  "Tirate al mento",
  "Trazioni",
  "Trazioni presa supina",
  "Treadmill run",
  "Triceps kickback",
  "Triceps pushdown",
  "Upright row",
  "Vogatore",
  "Walking lunge",
  "Wrist curl",
];

/** The id of the one datalist every exercise field on the page points at. */
export const EXERCISE_NAMES_LIST = "exercise-names";
